{
  "name": "@react-spectrum/provider",
  "version": "3.0.1",
  "description": "Spectrum UI components in React",
  "license": "Apache-2.0",
  "main": "dist/main.js",
  "module": "dist/module.js",
  "types": "dist/types.d.ts",
  "source": "src/index.ts",
  "files": [
    "dist",
    "src"
  ],
  "sideEffects": [
    "*.css"
  ],
  "targets": {
    "main": {
      "includeNodeModules": [
        "@adobe/spectrum-css-temp"
      ]
    },
    "module": {
      "includeNodeModules": [
        "@adobe/spectrum-css-temp"
      ]
    }
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/adobe/react-spectrum"
  },
  "dependencies": {
    "@babel/runtime": "^7.6.2",
    "@react-aria/i18n": "^3.0.1",
    "@react-aria/overlays": "^3.0.1",
    "@react-aria/utils": "^3.0.1",
    "@react-spectrum/utils": "^3.0.1",
    "@react-types/provider": "^3.0.1",
    "@react-types/shared": "^3.0.1",
    "classnames": "^2.2.5"
  },
  "devDependencies": {
    "@adobe/spectrum-css-temp": "^3.0.0-alpha.1"
  },
  "peerDependencies": {
    "react": "^16.8.0"
  },
  "publishConfig": {
    "access": "public"
  }
}
